import React, {useEffect, useState} from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TraitAddDialog from "./TraitAddDialog";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {getData} from "../api/AuthenticatedApiCaller";
import {TraitsApi} from "../api/AdminApi";
import EditIcon from "@mui/icons-material/Edit";
import {IconButton, Stack} from "@mui/material";
import Button from "@mui/material/Button";

export default function TraitsView() {
	const [traits, setTraits] = useState(null);
	const [editedTrait, setEditedTrait] = useState(null);
	const [type, setType] = useState("FUEL")
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const [currentTraitIndex, setCurrentTraitIndex] = useState(0);
	const [update, setUpdate] = useState(false);

	async function fetchData() {
		const [data, error] = await getData(TraitsApi.getAllByType + "?type=" + type);
		if (error) {
			// Handle the error
		} else {
			setTraits(data);
		}
	}

	useEffect(() => {
		if (traits === null || update) {
			fetchData();
		}
		setUpdate(false);

	}, [update]);

	const changeTraitIndex = (event, newValue) => {
		setCurrentTraitIndex(newValue);
		indexToType(newValue)
	};

	const indexToType = (index) => {
		switch (index) {
			case 0:
				setType("FUEL")
				setUpdate(true);
				break;

			case 1:
				setType("PASSENGERS")
				setUpdate(true);
				break;

			case 2:
				setType("DOORS")
				setUpdate(true);
				break;

			case 3:
				setType("TRANSMISSION")
				setUpdate(true);
				break;

			case 4:
				setType("LUGGAGE")
				setUpdate(true);
				break;

			case 5:
				setType("AC")
				setUpdate(true);
				break;
		}
	}


	return (
		<Box
			sx={{
				flexGrow: 1,
				bgcolor: "background.paper",
				display: "flex",
			}}
		>


			{traits !== null && (
				<TraitAddDialog
					open={isDialogOpen}
					trait={editedTrait}
					type={type}
					languages={traits.languages}
					save={() => {
						setIsDialogOpen(false);
						setUpdate(true);
					}}
					cancel={() => setIsDialogOpen(false)}
				/>
			)}


			<Tabs
				orientation="vertical"
				value={currentTraitIndex}
				onChange={changeTraitIndex}
				sx={{
					borderRight: 1,
					borderColor: "divider",
					width: 200,
					height: 400,
				}}
				centered
				variant="fullWidth"
			>


				<Tab label="FUEL"></Tab>
				<Tab label="PASSENGERS"></Tab>
				<Tab label="DOORS"></Tab>
				<Tab label="TRANSMISSION"></Tab>
				<Tab label="LUGGAGE"></Tab>
				<Tab label="AC"></Tab>

				<Button
					onClick={() => {
						console.log("OPEN")
						setEditedTrait(null)
						setIsDialogOpen(true);
					}}
					variant="contained"
				>
					Add Trait
				</Button>

			</Tabs>

			{traits !== null && (
				<TableContainer component={Paper}>
					<Table sx={{minWidth: 650}}>
						<TableHead>
							<TableRow key="header">
								<TableCell>Id</TableCell>
								{traits.languages.map((lang) => (
									<TableCell>{lang}</TableCell>
								))}
								<TableCell>Edit</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{
								traits.data.map((trait) => (
									<TableRow key={trait.id}>
										<TableCell>{trait.id}</TableCell>
										{trait.contents.map((content) => (
											<TableCell>{content.text}</TableCell>
										))}
										<TableCell>
											<IconButton>
												<EditIcon
													onClick={() => {
														setEditedTrait(trait);
														setIsDialogOpen(true);
													}}
												/>
											</IconButton>
										</TableCell>
									</TableRow>
								))
							}
						</TableBody>
					</Table>
				</TableContainer>
			)}
		</Box>
	);
}
